import React, {
  FC,
  ForwardedRef,
  forwardRef,
  PropsWithRef,
  ReactNode,
} from 'react';
import DropdownListItem from '@/src/components/clean/DropdownList/DropdownListItem/AdvancedDropdownListItem';

import style from './dropdownlist.style.module.scss';
import Icon from '@/src/v2/components/Icon';
import Image from 'next/legacy/image';
import { AvailableActionsType } from '@/src/resources/graphql/graphql-api.generated';
import { Icons } from '@/src/types/icon';

export type DropdownOption = {
  label: string;
  value: string;
  icon?: ReactNode;
  disable?: boolean;
};

type Props = {
  items: DropdownOption[];
  onClick: (value: string) => void;
  isOpen: boolean;
  header?: ReactNode;
  footer?: ReactNode;
  className?: string;
  selectedItems?: string[] | string;
  isSearch?: boolean;
  availableActions?: AvailableActionsType;
  channels?: any;
  isCountry?: boolean;
  isMultiselect?: boolean;
};

// eslint-disable-next-line react/display-name
const DropdownList: FC<PropsWithRef<Props>> = forwardRef(
  (
    {
      header,
      footer,
      isOpen,
      items,
      onClick,
      className,
      selectedItems = [] || '',
      isSearch = false,
      availableActions = undefined,
      channels,
      isCountry = false,
      isMultiselect = false,
    },
    ref
  ) => {
    const getImageUrl = (channelId: string): string => {
      const url = channels
        ? channels?.find((channel) => channel.id === channelId)?.avatar
        : null;
      return url;
    };

    return (
      <>
        {isOpen && (
          <div
            ref={ref as ForwardedRef<HTMLDivElement>}
            className={`${style['dropdown-list']} ${className}`}
          >
            {header && <>{header}</>}

            {items.map((item, index) => (
              <div
                className={`${
                  isSearch || isCountry
                    ? style['dropdown-list-with-search']
                    : ''
                }`}
              >
                {isSearch &&
                  (getImageUrl(item.value) ? (
                    <Image
                      layout={'fill'}
                      loader={(): any => {
                        return getImageUrl(item.value);
                      }}
                      src={getImageUrl(item.value)}
                      alt=""
                      objectFit="contain"
                    />
                  ) : (
                    <Icon width={20} icon="newKlicLogo" />
                  ))}
                {isCountry &&
                  (getImageUrl(item.value) ? (
                    <div>
                      <Image
                        layout={'fill'}
                        loader={(): any => {
                          return getImageUrl(item.value);
                        }}
                        src={getImageUrl(item.value)}
                        alt=""
                        objectFit="contain"
                      />
                    </div>
                  ) : (
                    <Icon
                      width={20}
                      icon={item.value.replace(/[\s-]+/g, '') as Icons}
                    />
                  ))}
                <DropdownListItem
                  key={index}
                  label={item.label}
                  onClick={() => onClick(item.value)}
                  icon={item.icon}
                  isSelected={
                    isMultiselect
                      ? selectedItems.includes(item.value)
                      : selectedItems === item.value
                  }
                  disable={item.disable}
                  isAvailable={
                    availableActions ? availableActions[item.value] : true
                  }
                />
              </div>
            ))}

            {footer && <>{footer}</>}
          </div>
        )}
      </>
    );
  }
);

export default DropdownList;
